import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Saldenliste(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Steuern & Auswertung"
      title="Summen- und Saldenliste – Buchungen detailliert nachvollziehen"
      subtitle="Die Summen- und Saldenliste zeigt alle Kontobewegungen übersichtlich auf. Perfekt für die Zusammenarbeit mit Ihrem Steuerberater."
      heroImage="/screenshots/app-buchhaltung.webp"
      heroImageAlt="Summen- und Saldenliste in Saldify mit Soll, Haben und Saldo je Konto"
      features={[
        {
          title: 'Alle Konten im Überblick',
          description: 'Sehen Sie Anfangsbestand, Soll- und Haben-Buchungen sowie Endbestand für jedes Konto.',
        },
        {
          title: 'Flexible Zeiträume',
          description: 'Erstellen Sie die SuSa für beliebige Zeiträume: Monat, Quartal, Jahr oder individuell.',
        },
        {
          title: 'SKR 03 & SKR 04',
          description: 'Unterstützung für die gängigen Kontenrahmen SKR 03 und SKR 04.',
        },
        {
          title: 'Drill-Down-Funktion',
          description: 'Klicken Sie auf ein Konto und sehen Sie alle Einzelbuchungen dahinter.',
        },
        {
          title: 'Vergleichsansicht',
          description: 'Vergleichen Sie Salden mit dem Vorjahr oder Budget direkt in der Übersicht.',
        },
        {
          title: 'DATEV-Export',
          description: 'Exportieren Sie die SuSa im DATEV-Format für Ihren Steuerberater.',
        },
      ]}
      sections={[
        {
          title: 'Transparenz für Sie und Ihren Steuerberater',
          description: 'Die Summen- und Saldenliste ist das zentrale Dokument für die Abstimmung mit Ihrem Steuerberater. Jede Buchung ist nachvollziehbar.',
          bullets: [
            'Alle Buchungen pro Konto',
            'Anfangs- und Endsaldo',
            'Soll/Haben-Bewegungen',
            'Abgestimmte Salden',
          ],
          imageSide: 'right',
        },
        {
          title: 'Von der Übersicht zum Detail',
          description: 'Mit der Drill-Down-Funktion springen Sie direkt von der Kontoübersicht zu den einzelnen Buchungen. Finden Sie schnell, was Sie suchen.',
          bullets: [
            'Ein Klick zur Buchungshistorie',
            'Belege direkt einsehen',
            'Buchungen bei Bedarf korrigieren',
            'Abstimmung dokumentieren',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Behalten Sie jede Buchung im Blick"
      ctaDescription="Mit der Summen- und Saldenliste haben Sie Ihre Buchhaltung vollständig unter Kontrolle."
    />
  );
}
